import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType } from "vue";
import { Employee } from "@/types/";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeCard',
  props: {
    employee: {
        type: Object as PropType<Employee>,
        required: true,
    },
},
  setup(__props) {



const isCurrent = computed(() => {
    return false;
    // return (
    //     this.$store.state.clients.current &&
    //     this.client.id === this.$store.state.clients.current.id
    // );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'EmployeeCard--current': isCurrent.value }, "EmployeeCard"])
  }, _toDisplayString(__props.employee.name), 3))
}
}

})